'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _lawForm = require('../actions/lawForm');

var _laws = require('../actions/laws');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchLaw),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(createLaw),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editLaw),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(deleteLaw),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(createLawRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editLawRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(deleteLawRequest);

function fetchLaw(_ref) {
    var id = _ref.id;
    var response;
    return regeneratorRuntime.wrap(function fetchLaw$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/laws/' + id);

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_lawForm.actionCreators.fetchLawSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_lawForm.actionCreators.fetchLawFailed(_context.t0));

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function createLaw(_ref2) {
    var law = _ref2.law,
        onSuccess = _ref2.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function createLaw$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/laws', law);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_lawForm.actionCreators.createLawSucceeded(response.data));

                case 6:
                    _context2.next = 8;
                    return (0, _effects.put)(_laws.actionCreators.fetchLawsRequest());

                case 8:
                    if (onSuccess) onSuccess();
                    _context2.next = 15;
                    break;

                case 11:
                    _context2.prev = 11;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 15;
                    return (0, _effects.put)(_lawForm.actionCreators.createLawFailed(_context2.t0.response ? _context2.t0.response.data : _context2.t0));

                case 15:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 11]]);
}

function editLaw(_ref3) {
    var law = _ref3.law,
        onSuccess = _ref3.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function editLaw$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/laws/' + law.id + '/full', law);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_lawForm.actionCreators.editLawSucceeded(response.data));

                case 6:
                    _context3.next = 8;
                    return (0, _effects.put)(_laws.actionCreators.fetchLawsRequest());

                case 8:
                    if (onSuccess) onSuccess();
                    _context3.next = 15;
                    break;

                case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 15;
                    return (0, _effects.put)(_lawForm.actionCreators.editLawFailed(_context3.t0.response ? _context3.t0.response.data : _context3.t0));

                case 15:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 11]]);
}

function deleteLaw(_ref4) {
    var id = _ref4.id,
        onSuccess = _ref4.onSuccess;
    return regeneratorRuntime.wrap(function deleteLaw$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'delete', '/laws/' + id);

                case 3:
                    _context4.next = 5;
                    return (0, _effects.put)(_lawForm.actionCreators.deleteLawSucceeded(id));

                case 5:
                    _context4.next = 7;
                    return (0, _effects.put)(_laws.actionCreators.fetchLawsRequest());

                case 7:
                    if (onSuccess) onSuccess();
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 14;
                    return (0, _effects.put)(_lawForm.actionCreators.deleteLawFailed(_context4.t0.response ? _context4.t0.response.data : _context4.t0));

                case 14:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 10]]);
}

function fetchLawRequest() {
    return regeneratorRuntime.wrap(function fetchLawRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_lawForm.actionTypes.FETCH_LAW_REQUEST, fetchLaw);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function createLawRequest() {
    return regeneratorRuntime.wrap(function createLawRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_lawForm.actionTypes.CREATE_LAW_REQUEST, createLaw);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editLawRequest() {
    return regeneratorRuntime.wrap(function editLawRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_lawForm.actionTypes.EDIT_LAW_REQUEST, editLaw);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function deleteLawRequest() {
    return regeneratorRuntime.wrap(function deleteLawRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_lawForm.actionTypes.DELETE_LAW_REQUEST, deleteLaw);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchLawRequest, createLawRequest, editLawRequest, deleteLawRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/lawForm.js
// module id = 2225
// module chunks = 0